var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCaret = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 24 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "caret",
  d: "M13.998 15.513a.43.43 0 0 1-.139.357.51.51 0 0 1-.679 0L9 12l4.18-3.87a.51.51 0 0 1 .68 0c.105.098.151.23.138.357L14 8.52v6.96q0 .017-.002.033"
}))), _use || (_use = /*#__PURE__*/React.createElement("use", {
  fill: "#435370",
  fillRule: "nonzero",
  transform: "matrix(-1 0 0 1 23 0)",
  xlinkHref: "#caret"
})));
export default SvgIconCaret;